/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  RESET_OTP,
  SET_IDP_CONFIG,
  SET_IDP_CONFIG_ERROR,
  SET_IDP_CONFIG_LOADING,
  SET_PASSWORDLESS_ERROR,
  SET_PASSWORDLESS_LENGTH,
  SET_PASSWORDLESS_LOGIN
} from "../actions/login-actions";
import { IDP_CONFIG_STATUS } from "../utils/constants";

const DEFAULT_STATE = {
  passwordless: {
    email: null,
    otpLength: 0,
    codeSent: false,
    error: false
  },
  idpConfig: {
    third_party_identity_providers: [],
    allows_native_auth: true,
    allows_otp_auth: true
  },
  idp_config_status: IDP_CONFIG_STATUS.LOADING
};

const baseReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case RESET_OTP: {
      return {
        ...state,
        passwordless: { ...state.passwordless, codeSent: false, error: false }
      };
    }
    case SET_PASSWORDLESS_LOGIN: {
      return {
        ...state,
        passwordless: { ...state.passwordless, email: payload, error: false }
      };
    }
    case SET_PASSWORDLESS_LENGTH: {
      const { otp_length: otpLength } = payload;
      return {
        ...state,
        passwordless: {
          ...state.passwordless,
          otpLength,
          codeSent: true,
          error: false
        }
      };
    }
    case SET_PASSWORDLESS_ERROR: {
      return { ...state, passwordless: { ...state.passwordless, error: true } };
    }
    case SET_IDP_CONFIG_LOADING: {
      const alreadyLoaded =
        state.idp_config_status === IDP_CONFIG_STATUS.LOADED;
      return {
        ...state,
        idp_config_status: alreadyLoaded
          ? IDP_CONFIG_STATUS.LOADED
          : IDP_CONFIG_STATUS.LOADING
      };
    }
    case SET_IDP_CONFIG: {
      return {
        ...state,
        idpConfig: payload,
        idp_config_status: IDP_CONFIG_STATUS.LOADED
      };
    }
    case SET_IDP_CONFIG_ERROR: {
      const alreadyLoaded =
        state.idp_config_status === IDP_CONFIG_STATUS.LOADED;
      return {
        ...state,
        idp_config_status: alreadyLoaded
          ? IDP_CONFIG_STATUS.LOADED
          : IDP_CONFIG_STATUS.ERROR
      };
    }
    default:
      return state;
  }
};

export default baseReducer;
